import { StrictMode } from "react";
import {createRoot} from "react-dom/client";
import {tns, TinySliderSettings} from "tiny-slider/src/tiny-slider";

import Availabilities from "./Availabilities/Availabilities";

/**
 * @param {HTMLDialogElement} popupDialogElm
 * @param {HTMLElement} itemsContainer
 * @param {TinySliderSettings} tnsSettings
 * @param {boolean} enableFilters
 */
export const renderAvailabilities = (popupDialogElm, itemsContainer, tnsSettings, enableFilters = false, enablePagination = false) => {
  const root = createRoot(itemsContainer);
  root.render(<StrictMode>
    <Availabilities popup={popupDialogElm} enableFilters={enableFilters} enablePagination={enablePagination} />
  </StrictMode>);

  // Observer to check if the apartments have been generated by react, and then creates the slider (tns)
  const observer = new MutationObserver((mutationList) => {
    const mutation = mutationList[mutationList.length - 1];

    switch (mutation.type) {
      case "childList": // If some child have been inserted to the availabilities block.
        if(enableFilters) {
          const childLength = itemsContainer.querySelector('.categories').children.length;

          if(childLength > 1 && mutation.addedNodes[0].classList.contains('categories')){
            const urlParams = new URLSearchParams(window.location.search);
            const myParam = urlParams.get('bedrooms');
            const filterTabs = document.querySelectorAll('.filter .tab')

            if(myParam === null) return
            if(myParam == 'studio' || parseInt(myParam) === 0) {
              filterTabs[1].click()
            }
            if([1,2,3].includes(parseInt(myParam))) {
              filterTabs[(parseInt(myParam) + 1)].click()
            }
            observer.disconnect();
          }

          if (childLength > 1 && mutation.target.classList.contains('categories')) {
            mutation.target.querySelectorAll('.list:not(.empty)').forEach(list => {
              tns({container: list.querySelector('.items'), ...tnsSettings});
            });

            observer.disconnect();
          }
        }else {
          if(mutation.target.children.length > 1) {
            tns({container: mutation.target, ...tnsSettings});
            observer.disconnect();
          }
        }
        break;
      default:
        break;
    }
  });

  // Start observing
  observer.observe(itemsContainer, {subtree: true, childList: true});
};
